import type { Positions } from "app/components/React/Charts/titles-positioner/titlesPositionerTypes";
import type { INumbersRecord } from "app/pages/industry-analysis/players/table/types";
import type { INumberRange } from "app/UtilitiesAndConstants/types/range";

export enum ETypes {
    AudienceGrowth,
    BrandStrength,
    CostEfficiency,
    Loyalty,
    ConversionRate,
}
export interface IAxisMetaData {
    range: INumberRange;
    average: number;
}

export interface IMetaData {
    xAxis: IAxisMetaData;
    yAxis: IAxisMetaData;
    zAxis: IAxisMetaData;
}

export interface IDataPoint {
    x: number;
    y: number;
    z: number;
    displayZ: number;
}

type DataPoints = Array<IDataPoint>;
interface IDataItem {
    name: string;
    subtitle: string;
    favicon: string;
    index: string;
    data: DataPoints;
    rawCurrentData?: Record<string, unknown>;
    rawCompareData?: Record<string, unknown>;
}

export type IChartData = Array<IDataItem>;

type QuadrantNameKeys = Record<Positions, string>;
export interface IAxis {
    titleKey?: string;
    titleTooltipKey?: string;
    tooltipTitleKey: string;
    formatter: (value: number) => string;
    attribute: keyof INumbersRecord;
    comparedAttribute?: keyof INumbersRecord;
}

interface IQuadrantNameKey {
    titleKey: string;
    tooltipKey: string;
}
export interface IChartOptionsMetaData {
    xAxis: IAxis;
    yAxis: IAxis;
    zAxis: IAxis;
    quadrantNameKeys: QuadrantNameKeys;
    chartTypeItems: IQuadrantNameKey;
    supportsIndustryWithSegments?: boolean;
    isSegmentsEnabled?: boolean;
}

export type SelectedEntitiesIDsT = Set<string>;

export type SelectedEntitiesColorMapT = Map<string, string>;
